import { API_URL } from './../enums/api-enums';
import { UtilitiesService } from './../../core/services/utilities.service';
import { SingleResponse } from './../model/restful-api.model';
import { Observable } from 'rxjs';
import { environment } from './../../../environments/environment.prod';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AssignmentGroupService {

  baseUrl = environment.portalURL;
  constructor(
    private util: UtilitiesService
  ) { }

  getRevokeRequestGroupName(app: string): Observable<SingleResponse<any>> {
    return this.util.req.httpGet<SingleResponse<any>>(this.baseUrl + API_URL.REVOKE_REQUEST
      + API_URL.ASSIGNMENT_GROUP + '?application=' + app);
  }

  getAccessRequestGroupName(app: string): Observable<SingleResponse<any>> {
    return this.util.req.httpGet<SingleResponse<any>>(this.baseUrl + API_URL.ACCESS_REQUEST
      + API_URL.ASSIGNMENT_GROUP + '?application=' + app);
  }

  getAccessRequestGroupNameForGeTagId(app: string): Observable<SingleResponse<any>> {
    return this.util.req.httpGet<SingleResponse<any>>(this.baseUrl + API_URL.ACCESS_ASSIGNMENT_GROUP + '?application=' + app);
  }

  updateRevokeRequestGroupName(app: string, name: string): Observable<SingleResponse<any>> {
    const model = {
      application: app,
      incidentAssignmentGroup: name
    };
    return this.util.req.httpPut<SingleResponse<any>>(this.baseUrl + API_URL.REVOKE_REQUEST
      + API_URL.ASSIGNMENT_GROUP, model);
  }

  updateAccessRequestGroupName(app: string, name: string): Observable<SingleResponse<any>> {
    const model = {
      application: app,
      incidentAssignmentGroup: name
    };
    return this.util.req.httpPut<SingleResponse<any>>(this.baseUrl + API_URL.ACCESS_REQUEST
      + API_URL.ASSIGNMENT_GROUP, model);
  }

  updateAccessRequestGroupNameForGeTagId(app: string, name: string): Observable<SingleResponse<any>> {
    const model = {
      application: app,
      incidentAssignmentGroup: name
    };
    return this.util.req.httpPut<SingleResponse<any>>(this.baseUrl + API_URL.UPDATE_ASSIGNMENT_GROUP, model);
  }
}
